<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <location-type-create-or-update v-model="locationType"></location-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { LocationTypeApi } from '@/api/location-type'
import LocationTypeCreateOrUpdate from './components/LocationTypeCreateOrUpdate.vue'
export default {
    components:{
        BCard,
        LocationTypeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Lokasyon Adı',key:'Name',sortable:true, thClass:'w-100'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            locationType:{
                Id:null,
                Name: null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.locationType.Id = null
            this.locationType.Name = null
            
        },
        provider(data){
            return LocationTypeApi.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.locationType.Id = item.Id
            this.locationType.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            LocationTypeApi.CreateOrUpdate(this.editing,this.locationType).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} adlı lokasyon tipini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    LocationTypeApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>